export {
  default as googlePayMark,
  ReactComponent as GooglePayMark,
} from '@assets/thirdParty/googlePayMark.svg'    
